import { createAction, props } from '@ngrx/store';

import { ItemSummary } from '@emm/core/models/item-summary.model';

export enum ItemChildrenAction {
    Load = '[Menu Tree] Load Item Children',
    LoadSuccess = '[Menu API] Load Item Children Success',
    LoadFailure = '[Menu API] Load Item Children Failure',
}

export const ItemChildrenActions = {
    load: createAction(ItemChildrenAction.Load, props<{ path: string }>()),
    loadSuccess: createAction(ItemChildrenAction.LoadSuccess, props<{ path: string; items: ItemSummary[] }>()),
    loadFailure: createAction(ItemChildrenAction.LoadFailure, props<{ error: any }>()),
};

export const ItemDetailAsyncActions = {
    loadActions: [ItemChildrenActions.load],
    successActions: [ItemChildrenActions.loadSuccess],
    errorActions: [ItemChildrenActions.loadFailure]
};
